// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__299Fe","inputWrap":"Table_inputWrap__yQQ0X","col":"Table_col__3YPDA","bmiTooltip":"Table_bmiTooltip__27L8m"};